import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip'; 
import { FaUsers } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';

export default function Salud(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [tiposSalud, settiposSalud] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <div className="btn-group">
                    <button type="button" className="btn btn-info" onClick={() => EditartipoSalud(row)} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Editar">
                        <FaUsers/>
                    </button>
                </div>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Tipo salud', selector: row => row.salDescripcion, sortable: true, width: '25%'},
        { name: 'Estado', selector: row => row.salActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        let url = `/parametros/tipossalud`;
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        settiposSalud(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function EditartipoSalud (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('salDescripcion', row.salDescripcion);
        setValue('salActivo', row.salActivo);
    };
    const NuevoTipoSalud = () =>  {
        setValue('id', 0);
        setValue('salDescripcion', '');
        setValue('salActivo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardartiposalud';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar tipo salud', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar tipo salud', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar tipo salud', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('salDescripcion', '');
        setValue('salActivo', false);
        setMuestraFormulario(false);
    }
    
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Tipos salud</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/parametros`} >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Tipo salud</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='salDescripcion'>Tipo salud</label>
                                                <input id='salDescripcion' {...register('salDescripcion', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Tipo estudio"/>
                                                {errors.salDescripcion && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('salActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button className='form-control' onClick={NuevoTipoSalud}>Nuevo</button>
                                <DataTable
                                    title="Tipo salud"
                                    columns={columns}
                                    data={tiposSalud}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}